<template>
    <VideoModal
        :id="blok._uid"
        :video="blok.video"
        :button-text="blok.text"
        :text-track-language="blok.vimeo_text_track_language"
        :text-track-kind="blok.vimeo_text_track_kind"
        :image="blok.image"
        image-class="block aspect-[3/2]"
    />
</template>

<script setup lang="ts">
import type { VideoEmbedStoryblok } from '~/app/types/storyblok-types';
import VideoModal from '../ui/VideoModal.vue';

defineProps<{ blok: VideoEmbedStoryblok }>();
</script>
